// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root___JOMz","s2":"classes_s2__Euqha"};